<template>
  <div class="checkout-qrcode-page">
    <div class="checkout-qrcode-container" v-if="!qrcodeIsLoading && !qrcodeIsError && qrcodeData">
      <div class="qrcode-image-container">
        <VueQrcode class="qrcode-img" :value="qrcodeData.rawQrCode" :options="options" />
        <img class="prompt-pay-icon" src="@/assets/images/ThaiQRpayments.png" />
      </div>
      <div class="qrcode-text">สแกน QR เพื่อโอนเข้าบัญชี</div>
    </div>
    <div class="manual-verify-text-container" :class="{ show: isShowManualVerify }">
      *หากผู้ชำระเบี้ยประกันภัยชำระเงินสำเร็จเรียบร้อยแล้ว
      <span class="bold-text">แต่ท่านยังไม่ได้รับข้อความตอบรับจากระบบ </span>
      <span class="highlight-text" @click="manualVerifySlip">กรุณากดที่นี่</span>
    </div>
    <div class="qrcode-loading-container" v-if="qrcodeIsLoading">
      <Loading />
    </div>
    <div class="qrcode-error-container" v-if="qrcodeIsError">
      something went wrong
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import VueQrcode from '@chenfengyuan/vue-qrcode'

import Loading from '@/components/Loading'
import API, { DOMAIN } from '@/lib/api'

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'QRCodeCheckout',
  props: ['application_id'],
  data: () => ({
    options: {
      width: 205,
    },
    isShowManualVerify: false,
  }),
  components: {
    Loading,
    VueQrcode,
  },
  watch: {
    applicationInformation: {
      handler(data) {
        const isCombinePayment = _.get(
          data,
          'applicationInformation.familyQuotation.isCombinePayment',
          false,
        )
        const socketId = this.webSocket.id

        if (isCombinePayment) {
          const familyId = _.get(data, 'applicationInformation.familyQuotation.familyId', '')
          const payload = {
            type: 'f',
            id: familyId,
            socketId: socketId,
          }
          this.payViaQRcode(payload)
        } else {
          const payload = {
            type: 'i',
            id: this.application_id,
            socketId: socketId,
          }
          this.payViaQRcode(payload)
        }
      },
      deep: true,
    },
    qrcodeData(data) {
      if (data) {
        setTimeout(() => {
          this.isShowManualVerify = true
        }, 5000)
      }
    },
    webSocket() {
      this.getApplicationInformation(this.application_id)

      this.webSocket.on('credit-noti', data => {
        this.$router.push(`/payment/qrcode/success/${this.application_id}`)
      })
    },
  },
  mounted() {
    const socketUrl = DOMAIN

    this.connectWebsocket(socketUrl)
  },
  computed: {
    ...mapPaymentFields({
      qrcodeData: 'qrcode.data',
      qrcodeIsLoading: 'qrcode.isLoading',
      qrcodeIsError: 'qrcode.isError',
    }),
    ...mapGetters(['applicationInformation', 'webSocket']),
  },
  methods: {
    ...mapActions([
      'getApplicationInformation',
      'payViaQRcode',
      'verifyQRSlip',
      'connectWebsocket',
      'disconnectWebsocket',
    ]),
    manualVerifySlip() {
      const qrId = this.qrcodeData.qrid
      const applicationId = this.application_id

      this.verifyQRSlip({ qrId, applicationId })
    },
  },
  destroyed() {
    this.disconnectWebsocket()
  },
}
</script>

<style lang="scss">
.checkout-qrcode-page {
  padding-top: 48px;
  position: relative;

  .checkout-qrcode-container {
    background-color: #fff;
    margin: 0 auto;
    min-width: 270px;
    padding: 32px 32px 60px;
    text-align: center;
    width: 50%;

    .qrcode-image-container {
      position: relative;

      .prompt-pay-icon {
        position: absolute;
        top: 50%;
        left: 51%;
        transform: translate(-50%, -50%);
        width: 40px;
      }
    }

    .qrcode-text {
      color: #000;
      font-family: 'psl_kanda_extraregular';
      font-size: 18px;
      line-height: 22px;
    }
  }

  .manual-verify-text-container {
    bottom: 48px;
    font-size: 14px;
    line-height: 18px;
    max-height: 0;
    overflow: hidden;
    padding: 0 32px;
    position: absolute;
    text-align: center;
    width: 100%;
    transition: max-height 0.3s ease-in-out 0s;

    &.show {
      max-height: 36px;
    }

    .highlight-text {
      color: #00a350;
      cursor: pointer;
      text-decoration: underline;

      @extend .bold-text;
    }

    .bold-text {
      font-family: 'psl_kanda_extraregular';
    }
  }

  .qrcode-error-container {
    text-align: center;
  }
}
</style>
